import * as z from "zod";

export const stopAutomationOutreachSplit = {
  name: "stopAutomationOutreachSplit" as const,
  input: z.object({ splitId: z.string() }),
  output: z.object({ success: z.boolean() }),
};
